//return -- | hh:mm
// export const formatDateWithTime = (date) => {
//   const d = new Date(date);
//   const day = d.getDate().toString().padStart(2, "0");
//   const month = (d.getMonth() + 1).toString().padStart(2, "0");
//   const year = d.getFullYear();
//   const hours = d.getHours().toString().padStart(2, "0");
//   const minutes = d.getMinutes().toString().padStart(2, "0");
//   return `${day}/${month}/${year} | ${hours}:${minutes}`;
// };
export const formatDateInput = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
export const reverseDateFormat = (dateString) => {
  const [day, month, year] = dateString.split("-");
  return `${year}-${month}-${day}`;
};
export const formatDate = (inputDate) => {
  if (!inputDate) return "--";

  const date = new Date(inputDate);
  if (isNaN(date.getTime())) return "--"; // Kiểm tra ngày hợp lệ

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
export const convertDateFormat = (dateString) => {
  // Kiểm tra chuỗi ngày hợp lệ
  if (!/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    throw new Error("Chuỗi ngày không đúng định dạng dd-mm-yyyy");
  }

  // Thay đổi dấu '-' thành '/'
  return dateString.replace(/-/g, "/");
};

export const formatDateToDDMMYYYY = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
